import { emptyValuePlaceholder, importErrorCopies, importFileErrorCopies, importFileErrorTypes } from './constants'

export const getImportErrorCopy = errorType => importErrorCopies[errorType] || errorType

export const getImportFileErrorCopy = fileError => {
  const key = importFileErrorCopies[fileError.error_type] || importFileErrorCopies[importFileErrorTypes.unexpected]

  if (fileError.error_type === importFileErrorTypes.missingRequiredColumns) {
    return { key, params: { columns: fileError.columns.join(', ') } }
  }

  return { key, params: {} }
}

export const getImportErrorRowValue = value => (value === '' ? emptyValuePlaceholder : value)
